(() => {
  // ------------------------------
  // Swiper CDN (pin version)
  // ------------------------------
  const SWIPER_CSS =
    "https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.css";
  const SWIPER_JS =
    "https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.js";

  // ------------------------------
  // Load Swiper CSS + JS once
  // ------------------------------
  function loadSwiperOnce() {
    if (window.__SWIPER_CDN_PROMISE__) return window.__SWIPER_CDN_PROMISE__;

    window.__SWIPER_CDN_PROMISE__ = new Promise((resolve, reject) => {
      if (window.Swiper) {
        resolve();
        return;
      }

      if (!document.querySelector(`link[href="${SWIPER_CSS}"]`)) {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = SWIPER_CSS;
        document.head.appendChild(link);
      }

      const existingScript = document.querySelector(
        `script[src="${SWIPER_JS}"]`
      );

      if (existingScript) {
        const check = setInterval(() => {
          if (window.Swiper) {
            clearInterval(check);
            resolve();
          }
        }, 50);

        setTimeout(() => {
          clearInterval(check);
          reject(new Error("Swiper load timeout"));
        }, 10000);

        return;
      }

      const script = document.createElement("script");
      script.src = SWIPER_JS;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () =>
        reject(new Error("Failed to load Swiper from CDN"));
      document.head.appendChild(script);
    });

    return window.__SWIPER_CDN_PROMISE__;
  }

  // ------------------------------
  // Slider definitions
  // ------------------------------
  const SLIDERS = [
    {
      name: "hero",
      selector: ".c__hero_custom_banner[data-hero-banner]",
      initFlag: "heroSwiperInit",
      buildConfig: (root) => ({
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: root.querySelector(".swiper-pagination"),
          clickable: true,
        },
        autoplay:
          root.dataset.autoplay !== "false"
            ? {
                delay: Number(root.dataset.autoplayDelay || 4000),
                disableOnInteraction: false,
              }
            : false,
      }),
    },

    {
      name: "bestsellers",
      selector: ".c__section_bestsellers[data-bestsellers]",
      initFlag: "bestsellersSwiperInit",
      buildConfig: (root) => ({
        slidesPerView: "auto",
        spaceBetween: Number(root.dataset.spaceBetween || 20),
        freeMode: true,
        scrollbar: {
          el: root.querySelector(".swiper-scrollbar"),
          hide: false,
          draggable: true,
        },
        navigation: {
          nextEl: root.querySelector(".swiper-button-next"),
          prevEl: root.querySelector(".swiper-button-prev"),
        },
      }),
    },

    {
      name: "reviews",
      selector: ".c__carousel_review[data-review-carousel]",
      initFlag: "reviewsSwiperInit",
      buildConfig: (root) => ({
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: root.querySelector(".swiper-pagination"),
          clickable: true,
        },
        navigation: {
          nextEl: root.querySelector(".swiper-button-next"),
          prevEl: root.querySelector(".swiper-button-prev"),
        },
        autoplay:
          root.dataset.autoplay !== "false"
            ? {
                delay: Number(root.dataset.autoplayDelay || 4000),
                disableOnInteraction: false,
              }
            : false,
      }),
    },

    {
      name: "mediaReview",
      selector: ".c__media_review[data-media-review]",
      initFlag: "mediaReviewSwiperInit",
      buildConfig: (root) => ({
        loop: true,
        autoHeight: true,
        pagination: {
          el: root.querySelector(".swiper-pagination"),
          clickable: true,
        },
        navigation: {
          nextEl: root.querySelector(".swiper-button-next"),
          prevEl: root.querySelector(".swiper-button-prev"),
        },
        autoplay:
          root.dataset.autoplay !== "false"
            ? {
                delay: Number(root.dataset.autoplayDelay || 4000),
                disableOnInteraction: false,
              }
            : false,
      }),
    },

    {
      name: "meetMoomExperts",
      selector: ".c__meet_moom_experts[data-meet-moom-experts]",
      initFlag: "meetMoomExpertsSwiperInit",
      buildConfig: (root) => ({
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        spaceBetween: 35,
        pagination: {
          el: root.querySelector(".swiper-pagination"),
          clickable: true,
        },
        breakpoints: {
          1000: {
            spaceBetween: 20,
            centeredSlides: false,
          },
        },
        navigation: {
          nextEl: root.querySelector(".swiper-button-next"),
          prevEl: root.querySelector(".swiper-button-prev"),
        },
      }),
    },

    {
      name: "reward",
      selector: ".c__section_reward[data-reward]",
      initFlag: "rewardSwiperInit",
      isMulti: true,
      buildConfig: (root, swiperEl) => ({
        slidesPerView: "auto",
        spaceBetween: Number(
          swiperEl.dataset.spaceBetween || root.dataset.spaceBetween || 20
        ),
        freeMode: true,
        pagination: {
          el: swiperEl.querySelector(".swiper-pagination"),
          clickable: true,
        },
        navigation: {
          nextEl: swiperEl.parentElement.querySelector(".swiper-button-next"),
          prevEl: swiperEl.parentElement.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
          1000: {
            spaceBetween: 20
          }
        }
      }),
    },

    {
      name: "specificProduct",
      selector: ".c__productwrapper[data-specific-product]",
      initFlag: "specificProductSwiperInit",
      buildConfig: (root) => ({
        loop: true,
        pagination: {
          el: root.querySelector(".swiper-pagination"),
          clickable: true,
        },
        navigation: {
          nextEl: root.querySelector(".swiper-button-next"),
          prevEl: root.querySelector(".swiper-button-prev"),
        },
      }),
    },

    {
      name: "productingredients",
      selector: ".c__productingredients[data-product-ingredients]",
      initFlag: "productingredientsSwiperInit",
      buildConfig: (root) => ({
        slidesPerView: "auto",
        spaceBetween: 9,
        freeMode: true,
        navigation: {
          nextEl: root.querySelector(".swiper-button-next"),
          prevEl: root.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
          1000: {
            spaceBetween: 20,
          },
        },
      }),
    },

    {
      name: "complementaryproducts",
      selector: ".c__complementaryproducts[data-complementary-product]",
      initFlag: "complementaryproductsSwiperInit",
      buildConfig: (root) => ({
        slidesPerView: "auto",
        spaceBetween: 9,
        freeMode: true,
        navigation: {
          nextEl: root.querySelector(".swiper-button-next"),
          prevEl: root.querySelector(".swiper-button-prev"),
        },
      }),
    },

    {
      name: "productreviews",
      selector: ".c__productreviews[data-product-reviews]",
      initFlag: "productreviewsSwiperInit",
      buildConfig: (root) => ({
        slidesPerView: "auto",
        spaceBetween: 15,
        freeMode: true,
        scrollbar: {
          el: root.querySelector(".swiper-scrollbar"),
          hide: false,
          draggable: true,
        },
        navigation: {
          nextEl: root.querySelector(".swiper-button-next"),
          prevEl: root.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
          1000: {
            spaceBetween: 20,
          },
        },
      }),
    },

    {
      name: "collection5starreviews",
      selector: ".c__collectionreviews[data-collection-reviews]",
      initFlag: "collectionreviewsSwiperInit",
      buildConfig: (root) => ({
        slidesPerView: "auto",
        spaceBetween: 9,
        freeMode: true,
        scrollbar: {
          el: root.querySelector(".swiper-scrollbar"),
          hide: false,
          draggable: true,
        },
        navigation: {
          nextEl: root.querySelector(".swiper-button-next"),
          prevEl: root.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
          1000: {
            spaceBetween: 20,
          },
        },
      }),
    },

    {
      name: "herocampaignmasthead",
      selector: ".c__herocampaignmasthead[data-curation-swiper]",
      initFlag: "herocampaignmastheadSwiperInit",
      buildConfig: (root) => ({
        slidesPerView: "auto",
        spaceBetween: 15,
        freeMode: true,
        scrollbar: {
          el: root.querySelector(".swiper-scrollbar"),
          hide: false,
          draggable: true,
        },
        navigation: {
          nextEl: root.querySelector(".swiper-button-next"),
          prevEl: root.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
          1000: {
            spaceBetween: 20,
          },
        },
      }),
    },

    {
      name: "loyaltytierswiper",
      selector: ".c__loyaltytierstatus[data-loyaltytier-swiper]",
      initFlag: "loyaltytierSwiperInit",
      buildConfig: (root) => ({
        spaceBetween: 20,
        autoHeight: true,
        navigation: {
          nextEl: root.querySelector(".swiper-button-next"),
          prevEl: root.querySelector(".swiper-button-prev"),
        },
      }),
    },
    
    {
      name: "activesubscriptionswiper",
      selector: ".c__subscriptionsummary[data-activesubscription-swiper]",
      initFlag: "activesubscriptionSwiperInit",
      buildConfig: (root) => ({
        slidesPerView: "auto",
        spaceBetween: 16,
        freeMode: true,
        scrollbar: {
          el: root.querySelector(".swiper-scrollbar"),
          hide: false,
          draggable: true,
        },
        navigation: {
          nextEl: root.querySelector(".swiper-button-next"),
          prevEl: root.querySelector(".swiper-button-prev"),
        },
      }),
    },
  ];

  // ------------------------------
  // Init / Destroy helpers
  // ------------------------------
  function initRoot(root, def) {
    if (!(root instanceof HTMLElement)) return;
    if (root.dataset[def.initFlag] === "1") return;

    if (def.isMulti) {
      const swipers = root.querySelectorAll(".s_swiper");
      if (!swipers.length) return;

      root.__swiperInstances = [];

      swipers.forEach((swiperEl) => {
        const instance = new Swiper(swiperEl, def.buildConfig(root, swiperEl));
        root.__swiperInstances.push(instance);
      });

      root.dataset[def.initFlag] = "1";
      return;
    }

    const container = root.querySelector(".swiper");
    if (!container) return;

    root.__swiperInstance = new Swiper(container, def.buildConfig(root));
    root.dataset[def.initFlag] = "1";
  }

  function destroyRoot(root, def) {
    if (!(root instanceof HTMLElement)) return;

    if (def.isMulti && root.__swiperInstances) {
      root.__swiperInstances.forEach((inst) => {
        if (inst && typeof inst.destroy === "function") {
          inst.destroy(true, true);
        }
      });
      delete root.__swiperInstances;
    }

    if (root.__swiperInstance) {
      root.__swiperInstance.destroy(true, true);
      delete root.__swiperInstance;
    }

    delete root.dataset[def.initFlag];
  }

  function collectMatches(scope = document) {
    const matches = [];

    SLIDERS.forEach((def) => {
      if (scope instanceof HTMLElement && scope.matches(def.selector)) {
        matches.push({ root: scope, def });
      }

      if (scope.querySelectorAll) {
        scope.querySelectorAll(def.selector).forEach((root) => {
          matches.push({ root, def });
        });
      }
    });

    return matches;
  }

  function initAll(scope = document) {
    const matches = collectMatches(scope);
    if (!matches.length) return;

    loadSwiperOnce()
      .then(() => {
        matches.forEach(({ root, def }) => initRoot(root, def));
      })
      .catch((err) => {
        console.error("Swiper failed to load:", err);
      });
  }

  function destroyInScope(scope = document) {
    SLIDERS.forEach((def) => {
      if (scope instanceof HTMLElement && scope.matches(def.selector)) {
        destroyRoot(scope, def);
      }

      if (scope.querySelectorAll) {
        scope.querySelectorAll(def.selector).forEach((root) => {
          destroyRoot(root, def);
        });
      }
    });
  }

  // ------------------------------
  // Boot + Shopify lifecycle
  // ------------------------------
  document.addEventListener("DOMContentLoaded", () => {
    initAll();
  });

  document.addEventListener("shopify:section:load", (e) => {
    initAll(e.target);
  });

  document.addEventListener("shopify:section:unload", (e) => {
    destroyInScope(e.target);
  });

  document.addEventListener("shopify:section:reorder", (e) => {
    destroyInScope(e.target);
    initAll(e.target);
  });

  document.addEventListener("shopify:block:load", (e) => {
    initAll(e.target);
  });

  document.addEventListener("shopify:block:unload", (e) => {
    destroyInScope(e.target);
  });

  // ------------------------------
  // Observe async DOM changes
  // ------------------------------
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        initAll(node);
      });

      mutation.removedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        destroyInScope(node);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // ------------------------------
  // Optional manual trigger
  // ------------------------------
  window.initAllSwipers = initAll;
  window.destroyAllSwipersInScope = destroyInScope;

  document.addEventListener('DOMContentLoaded', () => {
    const allSTools = document.querySelectorAll('.s_tools');

    allSTools.forEach((root) => {
      const checkCount = () => {
        const count = root.querySelectorAll('div[aria-disabled="true"]').length;

        if (count === 2) {
          root.classList.add('v_hidden'); // 👈 add class to this s_tools
          //observer.disconnect();
        } else {
          root.classList.remove('v_hidden');
        }
      };

      const observer = new MutationObserver(() => {
        checkCount();
      });

      observer.observe(root, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['aria-disabled'],
      });

      checkCount();
    });
  });
})();